(function() {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider
      .state('pendenciasRelatorioEleitoral', {
        url: "/membro/relatorioEleitoral/pendencias",
        templateUrl: 'module/corregedoria/relatorioEleitoral/pendencias/pendencias.html',
        controller: 'PendenciasRelatorioEleitoralController',
        controllerAs: 'vm',
      });
  }

})();